import { queryOptions, useQuery } from "@tanstack/react-query";
import React from "react";
// @ts-expect-error how does one type virtual module for typescript?
import commitHash from "virtual:commit-hash";
import { z } from "zod";

import { useToggle } from "@/common/hooks/use-toggle";
import { oneMinute } from "@/common/providers/query-provider";

// `-dirty` is appended to the commit hash if there are uncommitted changes.
const cleanCommitHash = commitHash.split("-")[0];

const VersionCheck = () => {
  const isLatestVersion = useToggle();
  const version = useQuery({
    ...versionQuery(),
    queryKey: ["app-version"],
    refetchInterval: oneMinute,
    refetchOnWindowFocus: true,
  });
  const isLatest = commitHash.includes(version.data);

  React.useEffect(() => {
    if (isLatest) {
      isLatestVersion.setOn();
    } else {
      isLatestVersion.setOff();
    }
  }, [isLatestVersion, isLatest]);

  if (version.status !== "success") {
    return;
  }

  if (!version.data) {
    return;
  }

  if (!isLatest) {
    window.location.reload();
  }

  return null;
};

const versionQuery = () =>
  queryOptions({
    queryFn: async ({ signal }): Promise<string | null> => {
      const commitHashSchema = z.object({ commitHash: z.string() });
      if (window.location.hostname === "localhost") {
        return commitHashSchema.parse({ commitHash: cleanCommitHash })
          .commitHash;
      }
      const version = await fetch(`/version.json?${Math.random()}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "GET",
        signal,
      });

      if (!version.ok) {
        return null;
      }

      const response = await version.json();

      const safeVersion = commitHashSchema.safeParse(response);

      return safeVersion.data?.commitHash ?? null;
    },
    queryKey: ["app-version"],
  });

export { VersionCheck };
